import { get } from './storage';

const DEFAULT_FEATURE_STATE = true;

export const FEATURES = {
  EMAIL_NOT_VERIFIED_POPUP: 'email.verification.popup',
  EXTENSION_NOT_INSTALLED_POPUP: 'extension.not.installed.popup',
};

function isEnabled(value) {
  try {
    return value !== false && value !== 0;
  } catch {
    return DEFAULT_FEATURE_STATE;
  }
}

async function checkFeatureAvailability(featureName) {
  if (!featureName) {
    return DEFAULT_FEATURE_STATE;
  }

  const FLAG_KEY = `feature:${featureName}`;
  const value = get(FLAG_KEY);
  return isEnabled(value);
}

const check = (featureName) => {
  return checkFeatureAvailability(featureName);
};

Object.defineProperty(check, 'feature', {
  get() {
    return new Proxy(FEATURES, {
      get(target, name) {
        return check(target[name]);
      },
    });
  },
});

export default check;

export async function getAll() {
  const results = await Promise.all(
    Object.values(FEATURES).map(async (featureName) => ({
      [featureName]: await check(featureName),
    })),
  );
  return results.reduce((obj, feature) => Object.assign(obj, feature), {});
}
